import { c as _c } from "react/compiler-runtime";
import { DropdownMenuItem } from '@repo/design-system/components/ui/dropdown-menu';
import { useT } from '@repo/i18n/components/i18n.client';
import { css } from '@repo/panda/css';
import { useLayerControl } from './hooks/useLayerControl';
export const LayerControlMenuItems = () => {
  const $ = _c(32);
  const {
    layerVisibility,
    hasLabels,
    hasRegions,
    has3dObjects,
    supportsLiveLocation,
    handleToggleLayer
  } = useLayerControl();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["game_map"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useT(t0);
  let t1;
  if ($[1] !== handleToggleLayer || $[2] !== has3dObjects || $[3] !== layerVisibility || $[4] !== t) {
    t1 = has3dObjects && <DropdownMenuItem value="rasterTiles" onSelect={() => handleToggleLayer("rasterTiles")} leadingIcon="map" leadingIconProps={{
      fill: true
    }} trailingIcon={layerVisibility.rasterTiles ? "check" : undefined}>{t(_temp)}</DropdownMenuItem>;
    $[1] = handleToggleLayer;
    $[2] = has3dObjects;
    $[3] = layerVisibility;
    $[4] = t;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== handleToggleLayer || $[7] !== hasLabels || $[8] !== layerVisibility || $[9] !== t) {
    t2 = hasLabels && <DropdownMenuItem value="labels" onSelect={() => handleToggleLayer("labels")} leadingIcon="label" leadingIconProps={{
      fill: true
    }} trailingIcon={layerVisibility.labels ? "check" : undefined}>{t(_temp2)}</DropdownMenuItem>;
    $[6] = handleToggleLayer;
    $[7] = hasLabels;
    $[8] = layerVisibility;
    $[9] = t;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== handleToggleLayer || $[12] !== hasRegions || $[13] !== layerVisibility || $[14] !== t) {
    t3 = hasRegions && <DropdownMenuItem value="regions" onSelect={() => handleToggleLayer("regions")} leadingIcon="select" leadingIconProps={{
      fill: true
    }} trailingIcon={layerVisibility.regions ? "check" : undefined}>{t(_temp3)}</DropdownMenuItem>;
    $[11] = handleToggleLayer;
    $[12] = hasRegions;
    $[13] = layerVisibility;
    $[14] = t;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== handleToggleLayer || $[17] !== has3dObjects || $[18] !== layerVisibility || $[19] !== t) {
    t4 = has3dObjects && <DropdownMenuItem value="objects3d" onSelect={() => handleToggleLayer("objects3d")} leadingIcon="deployed_code" leadingIconProps={{
      fill: true
    }} trailingIcon={layerVisibility.objects3d ? "check" : undefined}>{t(_temp4)}</DropdownMenuItem>;
    $[16] = handleToggleLayer;
    $[17] = has3dObjects;
    $[18] = layerVisibility;
    $[19] = t;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  let t5;
  if ($[21] !== handleToggleLayer || $[22] !== layerVisibility || $[23] !== supportsLiveLocation || $[24] !== t) {
    t5 = supportsLiveLocation && <DropdownMenuItem value="fogOfWar" onSelect={() => handleToggleLayer("fogOfWar")} leadingIcon="cloud" leadingIconProps={{
      fill: true
    }} trailingIcon={layerVisibility.fogOfWar ? "check" : undefined}>{t(_temp5)}<span className={css({
        backgroundColor: "white",
        color: "black",
        fontSize: "2xs",
        fontWeight: "bold",
        lineHeight: "none",
        px: "4",
        py: "2",
        borderRadius: "4",
        ml: "6",
        textTransform: "uppercase",
        letterSpacing: "wide"
      })}>Beta</span></DropdownMenuItem>;
    $[21] = handleToggleLayer;
    $[22] = layerVisibility;
    $[23] = supportsLiveLocation;
    $[24] = t;
    $[25] = t5;
  } else {
    t5 = $[25];
  }
  let t6;
  if ($[26] !== t1 || $[27] !== t2 || $[28] !== t3 || $[29] !== t4 || $[30] !== t5) {
    t6 = <>{t1}{t2}{t3}{t4}{t5}</>;
    $[26] = t1;
    $[27] = t2;
    $[28] = t3;
    $[29] = t4;
    $[30] = t5;
    $[31] = t6;
  } else {
    t6 = $[31];
  }
  return t6;
};
function _temp($) {
  return $.layer_2d;
}
function _temp2($_0) {
  return $_0.layer_labels;
}
function _temp3($_1) {
  return $_1.layer_regions;
}
function _temp4($_2) {
  return $_2.layer_3d;
}
function _temp5($_3) {
  return $_3.layer_fog_of_war;
}